<div class="login-page">
  <div class="app-login-form">
    <form (ngSubmit)="login()" #loginForm="ngForm">
      <div class="form-group">
        <input
          type="text"
          name="username"
          id="username"
          ngModel
          pInputText
          required
          [placeholder]="AUTH_STRINGS.label.username"
        />
      </div>
      <div class="form-group">
        <p-password
          name="password"
          feedback="false"
          ngModel
          [placeholder]="AUTH_STRINGS.label.password"
          [toggleMask]="true"
        />
      </div>
      <div class="form-group">
        <p-button
          type="submit"
          severity="danger"
          [label]="AUTH_STRINGS.label.login"
          [disabled]="!loginForm.valid"
          [loading]="loading"
          [outlined]="true"
        ></p-button>
      </div>
    </form>
    <div>
    <p>OR</p>
      <button pButton
            id="login-btn"
            type="submit"
            severity="danger"
            label="{{ AUTH_STRINGS.label.login_sso_btn }}"
            [disabled]="loading"
            [loading]="loading"
            [outlined]="true"
            (click)="onSsoLogin()"
          >
      </button>
    </div>
  </div>

  <img [src]="ASSETS.wgLion" alt="WG-lion-graphic" />
</div>
